import "core-js/modules/web.timers.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1d7cdbbf"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "flex items-center py-lg px-2xl bg-primary/30"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" Connection to server has been lost. Trying to reconnect"), /*#__PURE__*/_createElementVNode("span", {
    "class": "HeaderBanner__dots"
  }, ".")], -1);
});
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, " Maintenance works are scheduled today (8 November 20:00-20:30 UTC time). Maximum downtime is 30 minutes. Customer Portal and transfers can be affected during this time. ", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" Wide range of Smart contract interactions provided by Bequant Pro User API. Please find documentation "), /*#__PURE__*/_createElementVNode("a", {
    href: "/uapi-docs/#/defi",
    "class": "underline",
    target: "_blank"
  }, "here.")], -1);
});
import { useBanners } from "@/composables/useBanners";

import { onMounted } from 'vue';
export default {
  __name: 'HeaderBanner',
  props: {
    banner: {
      type: [Object, String],
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useBanners = useBanners(),
      removeBanner = _useBanners.removeBanner;
    onMounted(function () {
      if (props.banner.ttl) {
        setTimeout(function () {
          removeBanner({
            type: props.banner.type
          });
        }, props.banner.ttl);
      }
    });
    return function (_ctx, _cache) {
      var _component_PBIcon = _resolveComponent("PBIcon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.banner.type === 'connection-lost' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_PBIcon, {
        name: "no-connection",
        "class": "mr-lg text-primary"
      }), _hoisted_2], 64)) : _createCommentVNode("", true), __props.banner.type === 'maintenance' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_3, _createElementVNode("button", {
        "class": "ml-auto",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _unref(removeBanner)({
            type: 'maintenance'
          });
        })
      }, " Close ")], 64)) : _createCommentVNode("", true), __props.banner.type === 'defi' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_hoisted_4, _createElementVNode("button", {
        "class": "ml-auto",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _unref(removeBanner)({
            type: 'defi'
          });
        })
      }, " Close ")], 64)) : _renderSlot(_ctx.$slots, "default", {
        key: 3
      })]);
    };
  }
};